import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

// Renders a <tbody> that shows only the first `limit` item rows and hides the
// rest behind a "Total N products ( M units )" toggle footer. Auto-expands when
// `forceOpen` is true (e.g. an active search). Drop straight into any table that
// already provides its own <thead>.
export function CollapsibleItemRows({
  items = [],
  colSpan,
  renderRow,
  forceOpen = false,
  limit = 3,
  testid = "items",
}) {
  const [open, setOpen] = useState(false);
  const expanded = open || forceOpen;
  const shown = expanded ? items : items.slice(0, limit);
  const units = items.reduce((s, it) => s + (Number(it.quantity) || 0), 0);
  const hasMore = items.length > limit;

  return (
    <tbody>
      {shown.map(renderRow)}
      <tr className="bg-slate-50/70 border-t border-slate-200">
        <td colSpan={colSpan} className="px-3 py-1.5">
          <button
            type="button"
            disabled={!hasMore}
            onClick={() => setOpen(o => !o)}
            data-testid={`${testid}-collapse-toggle`}
            className={`inline-flex items-center gap-1.5 text-xs font-medium ${
              hasMore ? "text-sky-700 hover:text-sky-900 cursor-pointer" : "text-slate-500 cursor-default"
            }`}>
            Total {items.length} products ( {units} units )
            {hasMore && (expanded
              ? <ChevronDown className="w-3.5 h-3.5" />
              : <ChevronRight className="w-3.5 h-3.5" />)}
          </button>
        </td>
      </tr>
    </tbody>
  );
}
